const initialState = {
  rentals: [],
  totalElements: 0,
  loading: true
};

export function fetchRentalVehicles(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_RENTAL_VEHICLES.SUCCESS':
      return {
        ...state,
        rentals: action.rentalVehicles.body.content,
        totalElements: action.rentalVehicles.body.totalElements
      };
    default:
      return state
  }
}
